import { DEFAULT_PUBLIC_SITE_PUBLIC_UI_OPTIONS, type PublicSitePublicUiOptions } from "./publicSiteConfigLoaderTypes";

/**
 * When `loadPublicSiteConfig` has not filled the cache yet, derive `public_ui` from the build-time
 * deployment line so import-time / first-paint copy matches the active line. Once the API response is
 * cached, `peekPublicUiOptions` uses server `theme_json.public_ui` only.
 */
const LECOFFREIO_PUBLIC_UI_PEEK_FALLBACK: Partial<PublicSitePublicUiOptions> = {
	uses_estate_workspace_terms_in_ui_copy: true,
	my_account_show_idnot_portal_link: true,
};

export function publicUiOptionsPeekFallbackBeforeConfigLoad(): PublicSitePublicUiOptions {
	return { ...DEFAULT_PUBLIC_SITE_PUBLIC_UI_OPTIONS, ...LECOFFREIO_PUBLIC_UI_PEEK_FALLBACK };
}
